module.exports = __webpack_public_path__ + "img/maison-5.97b95ec6.png";